import actions from './actions';
import module from './module';
import routes from './routes';
import icons from './icons';
import apiErrors from './apiErrors';
import configuration from './configuration';
import nationality from './nationality';
import common from './common';
import cache from './cache';

export default (() => {
    return {
        actions,
        module,
        routes,
        icons,
        apiErrors,
        configuration,
        nationality,
        common,
        cache,
    };
})();
